import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = {
    expanded: { type: Boolean, default: false }
  }

  connect() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.render()
  }

  render() {
    if (this.expandedValue) {
      this.contentTarget.classList.remove("hidden")
      if (this.hasToggleTarget) {
        this.toggleTarget.innerHTML = `<i class="ti ti-chevron-up text-sm mr-1"></i> Hide advanced options`
      }
    } else {
      this.contentTarget.classList.add("hidden")
      if (this.hasToggleTarget) {
        this.toggleTarget.innerHTML = `<i class="ti ti-chevron-down text-sm mr-1"></i> Show advanced options`
      }
    }
  }
}
